import { Chip, Stack } from '@mui/material';
import React from 'react';

import type { ActionChip } from './types';

export interface PageHeaderQuickActionsProps {
  chips: ActionChip[];
}

const PageHeaderQuickActions: React.FC<PageHeaderQuickActionsProps> = ({
  chips,
}) => {
  if (chips.length === 0) return null;

  return (
    <Stack direction="row" spacing={1}>
      {chips.map((chip) => (
        <Chip
          key={chip.id}
          label={chip.label}
          onClick={chip.onClick}
          variant={chip.variant ?? 'outlined'}
          color={chip.color ?? 'primary'}
          size="small"
          sx={{ cursor: 'pointer' }}
        />
      ))}
    </Stack>
  );
};

export default PageHeaderQuickActions;
